import { get } from "svelte/store"
import { _ } from "svelte-i18n"
import {
    installationTypeCodesMap,
    modelGroupCodesMap,
    operationSources,
    productGroupCodesMap,
} from "../../../../config"
interface FilterConfig {
    [attribute: string]: {
        label: string
        operatorType: "stringArray" | "number"
        options?: { [dbValue: string]: { de: string } }
    }
}

export const filterConfig: FilterConfig = {
    installationType: {
        label: get(_)("components.pcalc.installationType"),
        operatorType: "stringArray",
        options: installationTypeCodesMap,
    },
    netPriceTotal: {
        label: get(_)("components.pcalc.netPrice"),
        operatorType: "number",
    },
    retailPriceTotal: {
        label: get(_)("components.pcalc.uvp"),
        operatorType: "number",
    },
    residentialUnitsCountTotal: {
        label: get(_)("components.pcalc.residentialUnitsCount"),
        operatorType: "number",
    },
    productGroup: {
        label: get(_)("components.pcalc.productGroup"),
        operatorType: "stringArray",
        options: productGroupCodesMap,
    },
    modelGroup: {
        label: get(_)("components.pcalc.modelGroup"),
        operatorType: "stringArray",
        options: modelGroupCodesMap,
    },
    originType: {
        label: get(_)("components.pcalc.originType"),
        operatorType: "stringArray",
        options: operationSources,
    },
}

export const stringArrayOperators = ["=", "!="]
export const numberOperators = ["=", "!=", ">", "<", ">=", "<="]

export const operatorMap: { [key: string]: string } = {
    "=": "eq",
    "!=": "ne",
    ">": "gt",
    "<": "lt",
    ">=": "ge",
    "<=": "le",
}

export const operatorTooltipMapWithExamples: { [key: string]: string } = {
    "=": get(_)("components.pcalc.equalsExample"),
    "!=": get(_)("components.pcalc.notEqualsExample"),
    ">": get(_)("components.pcalc.greaterExample"),
    "<": get(_)("components.pcalc.lessExample"),
    ">=": get(_)("components.pcalc.greaterOrEqualExample"),
    "<=": get(_)("components.pcalc.lessOrEqualExample"),
}
